import React, { useRef, useEffect } from 'react'
import Select, { components } from 'react-select'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import { AsyncPaginate } from 'react-select-async-paginate'
import { useTranslation } from 'react-i18next'

export default function Dropdown1({
  options,
  className,
  errorMessage = '',
  placeholder = '',
  id,
  isDisabled,
  isMulti,
  isSearchable = false,
  value,
  onBlur,
  onFocus,
  onChange,
  size,
  setRef,
  removeDropdownIcon = false,
  removeSeparator = true,
  customStyle = null,
  loadOptions = null,
  loading = false,
  onInputChange,
  menuPortalTarget = false,
  ...rest
}) {
  const { t } = useTranslation()
  const selectRef = useRef(null)
  useEffect(() => {
    if (setRef) {
      setRef(selectRef)
    }
  }, [])
  const dropdownOptionStyles = {
    option: (base, state) => {
      let backgroundColor = colorVariables.whitecolor
      let color = colorVariables.blueblack
      let fontWeight = 'normal'

      return {
        ...base,
        backgroundColor,
        color,
        fontWeight
      }
    }
  }
  return loadOptions ? (
    <AsyncPaginate
      ref={selectRef}
      value={value}
      isLoading={loading}
      loadingMessage={() => t('group.index.loading')}
      id={id}
      styles={customStyle ? customStyle : dropdownOptionStyles}
      className={`${styles.select} ${styles.selectedItem} ${className} ${styles[size]} ${
        errorMessage.length > 0 && styles.selectedItemError
      } ${isDisabled && styles.disabledSelectedItem}`}
      aria-errormessage={errorMessage}
      aria-invalid={errorMessage.length > 0}
      loadOptions={loadOptions}
      getOptionLabel={(option) => option.label || option.name}
      isClearable={false}
      closeMenuOnSelect={true}
      isDisabled={isDisabled}
      placeholder={placeholder}
      isMulti={isMulti}
      isSearchable={isSearchable}
      menuShouldScrollIntoView={true}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onInputChange={onInputChange}
      debounceTimeout={300}
      menuPortalTarget={menuPortalTarget ? document.querySelector('body') : false}
      components={{
        DropdownIndicator: removeDropdownIcon ? () => null : DropdownIndicator,
        IndicatorSeparator: removeSeparator ? () => null : IndicatorSeparator
      }}
      {...rest}
    />
  ) : (
    <Select
      classNamePrefix='mixr-select'
      ref={selectRef}
      value={value}
      id={id}
      isLoading={loading}
      styles={customStyle ? customStyle : dropdownOptionStyles}
      className={`${styles.select} ${styles.selectedItem} ${className} ${styles[size]} ${
        errorMessage.length > 0 && styles.selectedItemError
      } ${isDisabled && styles.disabledSelectedItem}`}
      aria-errormessage={errorMessage}
      aria-invalid={errorMessage.length > 0}
      options={options}
      getOptionLabel={(option) => option.label || option.name}
      getOptionValue={(option) => option.value || option.id}
      isClearable={false}
      closeMenuOnSelect={true}
      isDisabled={isDisabled}
      placeholder={placeholder}
      isMulti={isMulti}
      isSearchable={isSearchable}
      menuShouldScrollIntoView={true}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      menuPortalTarget={menuPortalTarget ? document.querySelector('body') : false}
      components={{
        DropdownIndicator: removeDropdownIcon ? () => null : DropdownIndicator,
        IndicatorSeparator: removeSeparator ? () => null : IndicatorSeparator
      }}
      {...rest}
    />
  )
}

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Icon name={props.selectProps.menuIsOpen ? 'chevron-up' : 'chevron-down'} />
      </components.DropdownIndicator>
    )
  )
}

const IndicatorSeparator = (props) => {
  return components.IndicatorSeparator && <components.IndicatorSeparator {...props} />
}
